module.exports = __webpack_public_path__ + "static/media/automobile.0becccd4.png";